export default __webpack_public_path__ + "static/consumare-energia-verde-5d1affa1262f9bb2bacd4d11f1c803a6.svg";